import { render, staticRenderFns } from "./CustomerCardComponent.vue?vue&type=template&id=1e48d254&scoped=true"
import script from "./CustomerCardComponent.vue?vue&type=script&lang=js"
export * from "./CustomerCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e48d254",
  null
  
)

export default component.exports